module.exports = __webpack_public_path__ + "img/02Icon.251f0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/02Icon.png
// module id = 0lqW
// module chunks = 0